module.exports = __webpack_public_path__ + "static/media/RainierSuperCompressed.a77f9107.jpg";